import {observable, action } from 'mobx';
import base from '../util/base';
import * as type from '../constants/type';
import * as API from '../apis/req';
export class conformRules {

  
  @observable conformRuleInfo = {};
  conformRuleSubmitEvent = null;
  conformRuleStopRequestEvent = null;

  @observable title = '';
  @observable status = false;
  @action('设置合规提示信息')
  setConformRuleInfo = info => {
      this.conformRuleInfo = info;
      if(info.result) {
        this.title = info.result.title;
        this.status = info.result.end;
      }
  }

  hasCheckedConformRule = false;
  @action setHasCheckedConformRule = (bool) => {
    this.hasCheckedConformRule = bool;
  }
  @action getCheckResult = (params) => {
    API.conformCheck(params).then( data => {
      this.setConformRuleInfo(data);
    }) 
  }
  setConformRuleSubmitEvent = (fun, stopFun) => {
    this.conformRuleSubmitEvent = fun;
    this.conformRuleStopRequestEvent = stopFun;
  }

  conformRuleCancelEvent = () => {
    base.globalStore.controlDialogVisible(type.CONFORM_RULE, false);
  }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/stores/conformRule.js